import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getCategoryDetails, updateCategory } from "../../helpers/http_categories_requests";
import { useQuery } from "@tanstack/react-query";

export default function CategoryUpdate() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getCategoryDetails', id], 
        queryFn: () => getCategoryDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: categoryData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Categoria - Editar",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updateCategory(data, () => navigate('/categorias'));
    };

    return <DynamicFormPage 
        isLoading={isFetching} 
        initialData={categoryData} 
        title={"Categoria - Editar"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
        onSubmit={handleSubmit} 
    />;
}
